import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // The panel is two stacked zones (#35586): a Pinned zone (only when something is sticky) sitting
  // above the active zone. A heavy divider under the Pinned zone keeps the two groups visually apart.
  pinnedZone: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 16,
    borderBottom: `2px solid ${theme.colors.card_primary_separator}`
  },
  activeZone: {
    display: 'flex',
    flexDirection: 'column'
  },
  zoneHeading: {
    marginBottom: 4,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.colors.button__background_secondary
  },
  notesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: 16
  },
  note: {
    padding: 14,
    borderRadius: 8,
    border: `1px solid ${theme.colors.card_primary_separator}`
  },
  stickyNote: {
    // Pinned notes stand out inside the Pinned zone.
    background: theme.colors.info__background_primary,
    borderColor: theme.colors.button__background_secondary
  },
  noteText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontSize: 14,
    lineHeight: 1.5
  },
  // The footer stacks vertically: the metadata gets its own full-width line and the controls
  // get theirs, so a long author email can never squeeze the actions off-screen (the old
  // single-row layout truncated "Delete" in the narrow sidebar).
  noteFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 12,
    paddingTop: 10,
    borderTop: `1px solid ${theme.colors.card_primary_separator}`
  },
  noteMeta: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    fontSize: 12,
    lineHeight: 1.4
  },
  noteAuthor: {
    // Wrap long emails onto a second line rather than clipping them — the author line no
    // longer shares its row with the action buttons, so it has the full width to use.
    fontWeight: 600,
    wordBreak: 'break-word'
  },
  noteDate: {
    opacity: 0.6
  },
  noteActions: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8
  },
  noteActionButtons: {
    display: 'flex',
    alignItems: 'center'
  },
  addRow: {
    // Sits at the top of the active zone; the divider separates it from the notes listed below.
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    padding: 16,
    borderBottom: `1px solid ${theme.colors.card_primary_separator}`
  },
  addControls: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8
  },
  editField: {
    width: '100%',
    marginBottom: 8
  },
  empty: {
    padding: 16,
    fontSize: 13,
    opacity: 0.7
  }
});

export default makeStyles(styles);
